module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"no_media":"此評論無附加照片/影片","filtered_review_mismatch":"所選評價與目前篩選條件不符。已為您顯示符合條件的第一條評價。","filtered_review_none":"目前篩選條件下沒有符合條件的評價。請重置篩選條件後再試。"}}')
  delete Component.options._Ctor
}
